import type { MultipleOpportunity, SingleOpportunity } from '@ps/web-sports-api-types';

import {
  getIsAvailableOpportunity,
  getIsSingleAvailableOpportunity
} from '@swf/core/models/sports/betSlip/utils/getIsOpportunity';

const getIsDefaultStartingPriceSelected = (
  opportunity: SingleOpportunity | MultipleOpportunity
): boolean => {
  const isStartingPriceOpportunity =
    getIsSingleAvailableOpportunity(opportunity) && opportunity.isStartingPriceOpportunity;
  const opportunityHasOdds = getIsAvailableOpportunity(opportunity) && opportunity.winRunnerOdds;
  return isStartingPriceOpportunity && !opportunityHasOdds;
};

export default getIsDefaultStartingPriceSelected;
